
import {
  GET_USERS_DATA,
  GET_USERS_DATA_SUCCESS,
  GET_USERS_DATA_FAILURE,
  GET_SINGLE_USER,
  GET_SINGLE_USER_SUCCESS,
  GET_SINGLE_USER_FAILURE
} from '../actions/userActions';

const INITIAL_STATE = {
  users: [],
  nextPage: null,
  prevPage: null,
  lastPage: null,
  status: null,
  error: null,
  loading: false,
  userToEdit:{
    user: null,
    status: null,
    error: null,
    loading: false
  }
};


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USERS_DATA:
      return { ...state, users: [], status: 'fetching', error: null, loading: true };
    case GET_USERS_DATA_SUCCESS:
      return { ...state, ...action.payload.data, status: 'fetched', error: null, loading: false };
    case GET_USERS_DATA_FAILURE:
      return { ...state, status: 'not-fetched', nextPage: null, prevPage: null, lastPage: null, error: action.payload.error, loading: true }
    case GET_SINGLE_USER:
      return { ...state, userToEdit: { user: null, status: 'fetching', error: null, loading: true } };
    case GET_SINGLE_USER_SUCCESS:
      return { ...state, userToEdit: { user: action.payload.data.user, status: 'fetched', error: null, loading: false } };
    case GET_SINGLE_USER_FAILURE:
      return { ...state, userToEdit: { user: null, status: 'not-fetched', error: action.payload.error, loading: false } };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/usersDataReducer.js